var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTripodWinch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.85,10.23v1.21c1.25,0,2.6.34,3.61-.1A9.32,9.32,0,0,1,36.6,11a.9.9,0,0,1,1,1,.93.93,0,0,1-1,1c-.71,0-1.42,0-2.13,0-.12,0-.29,0-.36,0-.77-.74-1.73-.38-2.61-.44-.54,0-1.08,0-1.62,0a2.65,2.65,0,0,0,.31,1.84C33.84,20.5,37.42,26.73,41,33l.33.6-1,.79c4,7,8,13.93,12.09,20.94L51.19,56,30,19.3l-.11,0v15l-.9.08V56H27.62V34.43l-1,0V19.25l-.14-.06h0Q15.88,37.57,5.23,56L4,55.28c4-7,8.05-14,12.09-21l-1-.78,2.79-4.83Q22.1,21.37,26.33,14a2.28,2.28,0,0,0,.26-1c0-.92,0-1.84,0-2.79ZM28.31,0a4.71,4.71,0,1,1-4.07,7.06H21a.74.74,0,0,1-.74-.74h0V3.09A.74.74,0,0,1,21,2.35h3.28A4.7,4.7,0,0,1,28.31,0Z",
    fill: "#0A0D0D"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTripodWinch);
export default __webpack_public_path__ + "static/media/tripod-winch.f8916dfc.svg";
export { ForwardRef as ReactComponent };